<template>
  <tr
    class="state-row"
    :class="{ 'state-row--highlighted': isHighlighted }"
    @mouseenter="$emit('hover', state.state)"
    @mouseleave="$emit('hover', null)">
    <td
      v-for="header in statisticsTableHeaders"
      :key="`state-${header.value}`"
      :class="header.align ? `text-${header.align}` : ''">
      <template v-if="header.value === 'name'">
        <div class="state-row__name">{{ state.state }}</div>
      </template>

      <template v-else-if="isDifference">
        <MetricCard :metricData="state[`${header.value}Diff`]" :invert-colors="header.value === 'noConnect'" />
      </template>

      <template v-else>
        <div :class="header.align ? `text-${header.align}` : ''">
          <span>{{ formatValue(state, header) }}</span>
        </div>
      </template>
    </td>
  </tr>
</template>

<script>
  import MetricCard from "@/components/custom/MetricCard";
  import { formatSecondsToHHMMSS } from "@/utility/formatDateTime/formatDateTime";
  import { formatNumber } from "@/@core/utils/filter";

  export default {
    name: "AbTestStateRow",
    components: {
      MetricCard,
    },
    props: {
      state: {
        type: Object,
        required: true,
      },
      statisticsTableHeaders: {
        type: Array,
        required: true,
      },
      isDifference: {
        type: Boolean,
        default: false,
      },
      isHighlighted: {
        type: Boolean,
        default: false,
      },
    },
    methods: {
      formatValue(item, header) {
        const value = item[header.value];

        if (value === undefined || value === null || value === "") {
          return "-";
        }

        if (header.value === "revenue" || header.value === "rpc" || header.value === "epv" || header.value === "cv") {
          return `$${formatNumber(value)}`;
        }

        if (header.value === "acl") {
          return formatSecondsToHHMMSS(value);
        }

        if (header.value === "callsCr" || header.value === "sessionsCr") {
          return `${value}%`;
        }

        return formatNumber(value);
      },
    },
  };
</script>

<style lang="scss" scoped>
  @import "@core/preset/preset/functions.scss";
  @import "@core/preset/preset/typography/index.scss";

  .state-row {
    td {
      background-color: get-color("element-bg-200");
    }

    &--highlighted {
      td {
        background-color: get-color("primary-10-hover");
      }

      .state-row__name {
        color: get-color("headline");

        &::before {
          background: get-color("primary");
        }
      }
    }

    &__name {
      position: relative;
      padding-left: 28px;
      color: get-color("subtitle");

      &::before {
        content: "";
        position: absolute;
        left: 12px;
        top: 0;
        bottom: 0;
        width: 2px;
        border-radius: 2px;
        background: get-color("primary-20");
      }
    }
  }
</style>
